/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  CalendarSubscription,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Generate personal calendar subscription
 */
export const createMyCalendarSubscription = (

 signal?: AbortSignal
) => {


      return axiosClient<CalendarSubscription>(
      {url: `/me/calendar/subscription`, method: 'POST', signal
    },
      );
    }




export const getCreateMyCalendarSubscriptionMutationKey = () => ['createMyCalendarSubscription'] as const;

export const getCreateMyCalendarSubscriptionMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyCalendarSubscription>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMyCalendarSubscription>>, TError,void, TContext> => {

const mutationKey = getCreateMyCalendarSubscriptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMyCalendarSubscription>>, void> = () => {


          return  createMyCalendarSubscription()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMyCalendarSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof createMyCalendarSubscription>>>

    export type CreateMyCalendarSubscriptionMutationError = ErrorType<StandardError>


    /**
 * @summary Generate personal calendar subscription
 */
export const useCreateMyCalendarSubscription = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyCalendarSubscription>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMyCalendarSubscription>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateMyCalendarSubscriptionMutationOptions(options), queryClient);
    }
    /**
 * @summary Disable personal calendar subscription
 */
export const destroyMyCalendarSubscription = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/me/calendar/subscription`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyMyCalendarSubscriptionMutationKey = () => ['destroyMyCalendarSubscription'] as const;

export const getDestroyMyCalendarSubscriptionMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMyCalendarSubscription>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyMyCalendarSubscription>>, TError,void, TContext> => {

const mutationKey = getDestroyMyCalendarSubscriptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyMyCalendarSubscription>>, void> = () => {


          return  destroyMyCalendarSubscription()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyMyCalendarSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof destroyMyCalendarSubscription>>>

    export type DestroyMyCalendarSubscriptionMutationError = ErrorType<StandardError>


    /**
 * @summary Disable personal calendar subscription
 */
export const useDestroyMyCalendarSubscription = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMyCalendarSubscription>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyMyCalendarSubscription>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroyMyCalendarSubscriptionMutationOptions(options), queryClient);
    }
    /**
 * @summary Show personal calendar subscription
 */
export const myCalendarSubscription = (

 signal?: AbortSignal
) => {


      return axiosClient<CalendarSubscription>(
      {url: `/me/calendar/subscription`, method: 'GET', signal
    },
      );
    }




export const getMyCalendarSubscriptionQueryKey = () => {
    return [
    'me','calendar','subscription'
    ] as const;
    }


export const getMyCalendarSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof myCalendarSubscription>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myCalendarSubscription>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMyCalendarSubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof myCalendarSubscription>>> = ({ signal }) => myCalendarSubscription(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof myCalendarSubscription>>, TError, TData>
}

export type MyCalendarSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof myCalendarSubscription>>>
export type MyCalendarSubscriptionQueryError = ErrorType<StandardError>


/**
 * @summary Show personal calendar subscription
 */

export function useMyCalendarSubscription<TData = Awaited<ReturnType<typeof myCalendarSubscription>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myCalendarSubscription>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMyCalendarSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Rotate personal calendar subscription
 */
export const rotateMyCalendarSubscription = (

 signal?: AbortSignal
) => {


      return axiosClient<CalendarSubscription>(
      {url: `/me/calendar/subscription/rotate`, method: 'POST', signal
    },
      );
    }




export const getRotateMyCalendarSubscriptionMutationKey = () => ['rotateMyCalendarSubscription'] as const;

export const getRotateMyCalendarSubscriptionMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateMyCalendarSubscription>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rotateMyCalendarSubscription>>, TError,void, TContext> => {

const mutationKey = getRotateMyCalendarSubscriptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateMyCalendarSubscription>>, void> = () => {


          return  rotateMyCalendarSubscription()
        }






  return  { mutationFn, ...mutationOptions }}

    export type RotateMyCalendarSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof rotateMyCalendarSubscription>>>

    export type RotateMyCalendarSubscriptionMutationError = ErrorType<StandardError>


    /**
 * @summary Rotate personal calendar subscription
 */
export const useRotateMyCalendarSubscription = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateMyCalendarSubscription>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof rotateMyCalendarSubscription>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRotateMyCalendarSubscriptionMutationOptions(options), queryClient);
    }
